export default __webpack_public_path__ + "static/media/snowuns-logo.38e6166b.png";